/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_OutInputs */

const en_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Out`)
};

const es_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const fr_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const de_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const ja_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト`)
};

const zh_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出登录`)
};

const ar_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الخروج`)
};

const id_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar`)
};

const it_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

const ru_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти`)
};

const pt_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const ko_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃`)
};

/**
* | output |
* | --- |
* | "Sign Out" |
*
* @param {Sign_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sign_out = /** @type {((inputs?: Sign_OutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_OutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sign_out(inputs)
	if (locale === "es") return es_sign_out(inputs)
	if (locale === "fr") return fr_sign_out(inputs)
	if (locale === "de") return de_sign_out(inputs)
	if (locale === "ja") return ja_sign_out(inputs)
	if (locale === "zh") return zh_sign_out(inputs)
	if (locale === "ar") return ar_sign_out(inputs)
	if (locale === "id") return id_sign_out(inputs)
	if (locale === "it") return it_sign_out(inputs)
	if (locale === "ru") return ru_sign_out(inputs)
	if (locale === "pt") return pt_sign_out(inputs)
	return ko_sign_out(inputs)
});